import { useCallback } from 'react';

type CopyContent = {
  html?: string;
  text: string;
};

type UseCopyToClipboardArgs = {
  onSuccess?(): void;
  onError?(): void;
};

export const useCopyToClipboard = ({ onError, onSuccess }: UseCopyToClipboardArgs = {}) => {
  const copyToClipboard = useCallback(
    async (content: CopyContent) => {
      try {
        if (content.html) {
          // Copy as rich HTML text with plain text fallback using modern Clipboard API
          const htmlBlob = new Blob([content.html], { type: 'text/html' });
          const textBlob = new Blob([content.text], { type: 'text/plain' });

          const clipboardItem = new ClipboardItem({
            'text/html': htmlBlob,
            'text/plain': textBlob,
          });

          await navigator.clipboard.write([clipboardItem]);
        } else {
          // Copy as plain text
          await navigator.clipboard.writeText(content.text);
        }
        onSuccess?.();
      } catch {
        onError?.();
      }
    },
    [onError, onSuccess]
  );

  return { copyToClipboard };
};
